const indexItems = [
  { title: '国产热播剧', count: '328部', icon: 'ri-fire-fill', color: 'accent' as const },
  { title: '韩剧大全', count: '186部', icon: 'ri-heart-fill', color: 'primary' as const },
  { title: '美剧精选', count: '142部', icon: 'ri-star-fill', color: 'secondary' as const },
  { title: '日剧推荐', count: '95部', icon: 'ri-sun-fill', color: 'accent' as const },
  { title: '古装传奇', count: '215部', icon: 'ri-building-2-fill', color: 'primary' as const },
  { title: '悬疑刑侦', count: '167部', icon: 'ri-search-eye-line', color: 'secondary' as const },
  { title: '都市情感', count: '198部', icon: 'ri-heart-pulse-line', color: 'accent' as const },
  { title: '玄幻史诗', count: '124部', icon: 'ri-thunderstorms-fill', color: 'primary' as const },
];

const colorMap = {
  accent: { bg: 'bg-accent-50', text: 'text-accent-600', iconBg: 'bg-accent-100', iconText: 'text-accent-600' },
  primary: { bg: 'bg-primary-50', text: 'text-primary-600', iconBg: 'bg-primary-100', iconText: 'text-primary-600' },
  secondary: { bg: 'bg-secondary-50', text: 'text-secondary-700', iconBg: 'bg-secondary-100', iconText: 'text-secondary-700' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 mb-3">
            剧集分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按品类快速发现你感兴趣的热播电视剧，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, index) => {
            const colors = colorMap[item.color];
            return (
              <div
                key={index}
                className="group p-4 md:p-5 rounded-xl border border-background-200 bg-background-50 hover:border-primary-300 cursor-pointer transition-all"
              >
                <div className={`w-10 h-10 md:w-11 md:h-11 rounded-xl ${colors.iconBg} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                  <i className={`${item.icon} ${colors.iconText} text-lg`}></i>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.count}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}